





















import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import UiList from '@superUI/List/List'

settings =
  name: "EventSetList"
  components: { SuperContainerView, UiList }
  resources:
    event_sets:
      resourceName: "event_sets"
      slug: "event_sets"
      infinityScroll: true

export default VueOptions.vue settings
